import { render, staticRenderFns } from "./CannedResponses.vue?vue&type=template&id=bcb37e92&"
import script from "./CannedResponses.vue?vue&type=script&lang=js&"
export * from "./CannedResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports